import * as React from "react"

const PhoneTalkFooter = (props) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.045 17.52c-.656-.55-4.5-2.984-5.14-2.872-.3.053-.529.309-1.143 1.041-.284.36-.596.699-.933 1.01a8.068 8.068 0 0 1-1.78-.66A11.025 11.025 0 0 1 7.96 10.95a8.067 8.067 0 0 1-.66-1.78c.311-.337.65-.65 1.01-.934.732-.614.988-.842 1.041-1.143.112-.64-2.325-4.484-2.872-5.14-.23-.27-.438-.453-.705-.453C5.001 1.5 1.5 5.829 1.5 6.39c0 .046.075 4.553 5.767 10.343 5.79 5.692 10.297 5.767 10.343 5.767.561 0 4.89-3.501 4.89-4.275 0-.267-.182-.476-.455-.705ZM17.25 11.25h1.5a6.007 6.007 0 0 0-6-6v1.5a4.505 4.505 0 0 1 4.5 4.5Z"
      fill="#EA84AB"
    />
    <path
      d="M21 11.25h1.5a9.761 9.761 0 0 0-9.75-9.75V3A8.26 8.26 0 0 1 21 11.25Z"
      fill="#EA84AB"
    />
  </svg>
)

export default PhoneTalkFooter
